import React, {FC} from "react";
import FileMgrDashBoard from "../DocumentMgr/FileUseAgeDashBoard/FileMgrDashBoard";
import FileMgrExtention from "../DocumentMgr/ExtensionMgr/FileMgrExtension";
import UserMgr from "../UserMgr/UserMgr";
import MonitorDocuwizRest from "../Monitoring/MonitorDocuwizRest";
import AesMgr from "../Security/AesMgr";
import JwtMgr from "../Security/JwtMgr";
import StorageRest from "../StorageMgr/StorageRest";
import ArchiveMgr from "../StorageMgr/ArchiveMgr";
import StorageInfra from "../StorageMgr/StorageInfra";
import BatchMgr from "../BatchMgr/BatchMgr";
import ReleaseMgr from "../ReleaseMgr/ReleaseMgr";
import StorageFTP from "../ExStorage/StorageFTP";
import SapMgr from "../SAPMgr/SapMgr";
import ArchiveFolderMgr from "../StorageMgr/ArchiveFolderMgr";
import MonitorRFC from "../Monitoring/MonitorRFC";
import MonitorBatch from "../Monitoring/MonitorBatch";
import DocumentTypeMgr from "../DocumentMgr/DocumentType/DocumentTypeMgr";
import StorageFileMgr from "../StorageMgr/StorageFileMgr";
import DocumentMgrPage from "../../../Conditional-Rendering/admin/index/DocumentMgrPage";
import LinkedKeyMgr from "../DocumentMgr/LinkedKeyMgr/LinkedKeyMgr";


type RenderComponentProps = {
    menuKey: string;
};
const RenderComponent: FC<RenderComponentProps> = ({ menuKey }) => {

    switch (menuKey) {
        case '문서관리/현황':
            return <FileMgrDashBoard />;
        case '문서관리/문서관리':
            return <DocumentMgrPage />;
        case '문서관리/문서종류관리':
            return <DocumentTypeMgr />;
        case '문서관리/확장자관리':
            return <FileMgrExtention />;
        case '문서관리/연결코드관리':
            return <LinkedKeyMgr />;
        case '배치관리/배치관리':
            return <BatchMgr/>;
        case '배포관리/배포관리':
            return <ReleaseMgr/>;
        case '사용자관리/권한관리':
            return <UserMgr/>;
        case '모니터링/DB 트랜젝션':
            return <MonitorDocuwizRest/>;
        case '모니터링/배치':
            return <MonitorBatch/>;
        case '모니터링/SAP RFC':
            return <MonitorRFC/>;
        case '모니터링/RCMS':
            return <MonitorDocuwizRest/>;
        case '모니터링/EZBARO':
            return <MonitorBatch/>;
        case '보안관리/파일암호화':
            return <AesMgr/>;
        case '보안관리/로그인토큰':
            return <JwtMgr/>;
        case '스토리지관리/아카이브설정':
            return <ArchiveMgr/>;
        case '스토리지관리/폴더관리':
            return <ArchiveFolderMgr/>;
        case '스토리지관리/파일관리':
            return <StorageFileMgr/>;
        case '스토리지관리/RESTAPI설정':
            return <StorageRest/>;
        case '스토리지관리/경로설정':
            return <ArchiveMgr/>;
        case '스토리지관리/인프라설정':
            return <StorageInfra/>;
        case '외부저장소관리/FTP관리':
            return <StorageFTP/>;
        case '인터페이스관리/SAP접속관리':
            return <SapMgr/>;
        default:
            return <div>{menuKey}</div>;
    }


};

export default RenderComponent;